export default function updateLogger() {
  /* NOOP */
}
